import {
    ExAccordion,
    ExAccordionItem,
    ExStructuredList,
    ExStructuredListBody,
    ExStructuredListCol,
    ExStructuredListRow,
} from '@boomi/exosphere';
import type {
    ResponseHeaders,
    RootFaultsResponseApi,
    SingleFault,
} from '../../../../../types/debugger';
import ErrorBoundary from '../../../../generic/ErrorBoundary';
import RootFaultResponseHeaders from './RootFaultResponseHeaders';

interface Props {
    rootFaults: RootFaultsResponseApi | null;
}

interface RootFaultsToDisplay {
    fault: string;
    details: SingleFault | string;
}

const parseFault = (fault: string): SingleFault | string => {
    try {
        return JSON.parse(fault);
    } catch {
        return fault;
    }
};

const getFaultsToDisplay = (
    rootFaults: RootFaultsResponseApi | null,
): RootFaultsToDisplay[] | null =>
    rootFaults
        ? Object.entries(rootFaults).map(([key, val]) => ({
              fault: key,
              details: parseFault(val),
          }))
        : null;

const RootFaultsAccordion = ({ rootFaults }: Props) => {
    const rootFaultsToDisplay = getFaultsToDisplay(rootFaults);

    return (
        <>
            {rootFaultsToDisplay ? (
                <ExAccordion>
                    {rootFaultsToDisplay.map((rootFaultToDisplay) => (
                        <ExAccordionItem
                            key={rootFaultToDisplay.fault}
                            label={rootFaultToDisplay.fault}
                        >
                            <ExStructuredList>
                                <ExStructuredListBody>
                                    {typeof rootFaultToDisplay.details === 'string' ? (
                                        <ExStructuredListRow>
                                            <ExStructuredListCol>
                                                <div className="ex-fs-micro">
                                                    {rootFaultToDisplay.details}
                                                </div>
                                            </ExStructuredListCol>
                                        </ExStructuredListRow>
                                    ) : (
                                        Object.entries(rootFaultToDisplay.details).map(
                                            ([key, detail]) => {
                                                return (
                                                    <ExStructuredListRow key={key}>
                                                        {/* Flow does not strictly type the root faults so using an error boundary to be safe */}
                                                        <ErrorBoundary>
                                                            {key === 'responseHeaders' && detail ? (
                                                                <RootFaultResponseHeaders
                                                                    headers={
                                                                        detail as ResponseHeaders
                                                                    }
                                                                />
                                                            ) : (
                                                                <ExStructuredListCol>
                                                                    <div>
                                                                        <b>{key}</b>
                                                                    </div>
                                                                    <div className="ex-fs-micro">
                                                                        {detail as string}
                                                                    </div>
                                                                </ExStructuredListCol>
                                                            )}
                                                        </ErrorBoundary>
                                                    </ExStructuredListRow>
                                                );
                                            },
                                        )
                                    )}
                                </ExStructuredListBody>
                            </ExStructuredList>
                        </ExAccordionItem>
                    ))}
                </ExAccordion>
            ) : (
                <div className="center">No root faults to display</div>
            )}
        </>
    );
};

export default RootFaultsAccordion;
